import React from 'react';
import {
	TaskRowHeader as TaskRowHeaderComponent,
	TaskRowHeaderV2 as TaskRowHeaderComponentV2,
} from 'web-components';
import * as tracking from '../../../../../tracking';
import {hasFeatureFlag} from '../../../util/FeatureUtil';

const TaskListHeader = ({intl, enabledColumns, sortBy, onSortByChange, stickyTopPosition, isInContainer, featureFlags}) => {

	// This is handling two versions of the TaskRow / TaskHeader for supporting the new Sub Task with a feature flag
	// PLEASE CLEAN THIS UP AFTERWARDS.
	const useTaskHierarchy = featureFlags && hasFeatureFlag('task_hierarchy', featureFlags) && hasFeatureFlag('task_hierarchy_part2', featureFlags);
	const MyTaskRowHeaderComponent = useTaskHierarchy ?
		TaskRowHeaderComponentV2 :
		TaskRowHeaderComponent;

	return <MyTaskRowHeaderComponent intl={intl} columns={enabledColumns} sortBy={sortBy} onSortByChange={onSortByChange} stickyTopPosition={stickyTopPosition} isInContainer={isInContainer} tracking={tracking} />;
};

export default TaskListHeader;
